<template>
  <IndexBlok :id="6"></IndexBlok>
</template>

<script>

    import IndexBlok from "../../components/Doc/IndexBlok";
    export default {
        components: {IndexBlok},
        data() {
            return {
                MenuList: null,
                Modul: null
            }
        },
        methods: {
            SayfaYukle() {
                this.$store.dispatch("Get", {path: 'kilavuz/liste/6'})
                    .then(response => {
                        this.MenuList = response.Data;
                        this.Modul = response.Modul;
                    });
            }
        },
        created() {
            this.SayfaYukle();
            window.addEventListener('keyup', event => {
                //if (event.key === "1") router.push("/yonetim/sirket");
                //if (event.key === "2") router.push("/yonetim/site");
                //if (event.key === "3") router.push("/yonetim/bina");
                //if (event.key === "4") router.push("/yonetim/mesken");
                //if (event.key === "5") router.push("/yonetim/kisi");
            });
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Iletisim/index.vue